import api from './client'
import type { User } from '../types'

export type CreateUserResponse = {
  data: User
  email?: {
    sent: boolean
    message: string
  }
}

export type UserUpsertPayload = {
  fullName: string
  email?: string
  role?: User['role']
  password?: string
  isActive?: boolean
  canSubmitExpenses?: boolean
  removeAvatar?: boolean
  avatar?: File | null
}

function toFormData(data: UserUpsertPayload): FormData {
  const formData = new FormData()
  formData.set('fullName', data.fullName)
  if (data.email !== undefined) formData.set('email', data.email)
  if (data.role !== undefined) formData.set('role', data.role)
  if (data.password) formData.set('password', data.password)
  if (data.isActive !== undefined) formData.set('isActive', String(data.isActive))
  if (data.canSubmitExpenses !== undefined) formData.set('canSubmitExpenses', String(data.canSubmitExpenses))
  if (data.removeAvatar) formData.set('removeAvatar', 'true')
  if (data.avatar) formData.set('avatar', data.avatar)
  return formData
}

export const usersApi = {
  listUsers: () => api.get<{ data: User[] }>('/users'),

  getUser: (id: string) => api.get<{ data: User }>(`/users/${id}`),

  createUser: (data: UserUpsertPayload) =>
    api.post<CreateUserResponse>('/users', toFormData(data)),

  updateUser: (id: string, data: UserUpsertPayload) =>
    api.put<{ data: User }>(`/users/${id}`, toFormData(data)),
}
